// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error[data-v-257eb9d9]{\n  height: 20px;\n  color: #f00;\n  font-weight: 600;\n}\ndiv.licence ul li.my-used-class[data-v-257eb9d9]{\nopacity: 0.25 !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
